import React from "react";
import getParticipantStatusStyle from "../../../utils/getParticipantStatusStyle";

const DiscordParticipantsList = ({
  combinedList,
  pairedCount,
  showUnpairedOnly,
  onToggleShowUnpaired,
  onOpenLinksModal,
}) => (
  <div className="dc-column">
    <div className="dc-column-header">
      <div className="dc-column-header-left">
        <div className="dc-column-title">Osoby z rezerwacji</div>
        <span className="dc-column-subtitle">
          🔗 Powiązanych {pairedCount} / {combinedList.length}
        </span>
      </div>

    <div className="dc-edit-icon" onClick={onOpenLinksModal} title="Edytuj powiązania">
      <i className="fa fa-pen-to-square" />
    </div>
    </div>

    <div className="dc-user-list">
      {combinedList.length === 0 ? (
        <div style={{ color: "#777", fontStyle: "italic", padding: "8px" }}>
          Brak uczestników.
        </div>
      ) : (
        combinedList.map((item, i) => {
          const statusStyle = getParticipantStatusStyle(item.status);
          const isDisabled = item.isActive === false;
          return (
            <div key={i}  className={`dc-user-row ${isDisabled ? "dc-user-row-disabled" : ""}`}>
              <div className="dc-user-left">
                <i
                  className={`fa ${statusStyle.icon} dc-user-icon ${statusStyle.statusClass}`}
                />
                <span
                  className={`dc-user-name ${
                    statusStyle.strikeThrough ? "dc-strikethrough" : ""
                  }`}
                >
                  {item.participantName}
                </span>
              </div>

              {item.isPaired && (
                <div className="dc-discord-user">
                  {item.avatarUrl && (
                    <img
                      src={item.avatarUrl}
                      alt={item.displayName}
                      className="dc-discord-avatar"
                    />
                  )}
                  <div className="dc-discord-info">
                    <span
                      className="dc-discord-display"

                    >
                      {item.displayName}
                    </span>
                    <span className="dc-discord-username">(@{item.userName})</span>
                  </div>
                </div>
              )}

            </div>
          );
        })
      )}
    </div>
  </div>
);

export default DiscordParticipantsList;
